/**
 * Sinoboom i-Link integration — settings + manual sync (super admin only,
 * server-enforced). The stored API password is never returned to the browser;
 * `has_password` tells the UI whether one is set.
 */
import apiClient from '../api/client';

const sinoboomService = {
    async getSettings() { return apiClient.get('/sinoboom/settings'); },
    async saveSettings(patch) { return apiClient.put('/sinoboom/settings', patch); },
    async syncNow() { return apiClient.post('/sinoboom/sync-now', {}); },
    /**
     * Walk the whole i-Link chain and report which step fails. Credentials may
     * be passed to try them BEFORE saving; the server writes nothing and never
     * echoes the password back.
     */
    async testConnection(creds) { return apiClient.post('/sinoboom/test-connection', creds || {}); },
    /** Per-machine telemetry state: ids resolved, freshness, last error. */
    async telemetryStatus() { return apiClient.get('/sinoboom/telemetry'); },
};

export default sinoboomService;
